import { styled } from "@mui/material/styles";
import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogProps,
    Grid,
    InternalStandardProps,
} from "@mui/material";
import { AppButton } from "./AppButton";
import { AppTypography } from "./AppTypography";

const DialogWrapper = styled(Box)(({ theme }) => ({
    backgroundColor: `${theme.palette.background.default}`,
}));

const Grey600Text = styled(AppTypography)(({ theme }) => ({
    color: theme.palette.grey[600],
}));

export interface AppEmptyAlertDialogProps
    extends InternalStandardProps<DialogProps> {
    onClose: () => void;
    popupMainText: string;
    cancelButtonText: string;
    showConfirmFirst?: boolean;
}

export const AppEmptyAlertDialog = (props: AppEmptyAlertDialogProps) => {
    const {
        className,
        onClose,
        cancelButtonText,
        popupMainText,
        showConfirmFirst,
        ...rest
    } = props;

    return (
        <Dialog
            maxWidth={"sm"}
            fullWidth
            className={className}
            {...rest}
        >
            <DialogWrapper>
                <DialogContent>
                    <Grid container>
                        <Grid item xs={12}>
                            <Grey600Text variant="body1">
                                {popupMainText}
                            </Grey600Text>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    {!showConfirmFirst && (
                        <>
                            <AppButton
                                buttonVariant="grey-text"
                                onClick={onClose}
                            >
                                {cancelButtonText}
                            </AppButton>
                        </>
                    )}
                </DialogActions>
            </DialogWrapper>
        </Dialog>
    );
};
